module.exports = __webpack_public_path__ + "static/media/specialMenu.8066f8c3.pdf";